// extracted by mini-css-extract-plugin
export default {"content":"Categories_content__XfIQK","subCategoryColumn":"Categories_subCategoryColumn__54hPD"};